import { PERMISSIONS } from '@/common/constants';
import store from '@/store';

export function permission({ permission }) {
  const account = store.state.loggedAccount && store.state.loggedAccount.account;
  const permissions = account && account.permissions;

  if (permission) {
    if (permission.role !== account.role || permissions.find(el => el.name === PERMISSIONS[permission.name])) return;
    if (permission.fallbackPage) throw { name: permission.fallbackPage };
    else throw { name: 'NotFound' };
  }
}
